import { render, staticRenderFns } from "./clockDataDetall.vue?vue&type=template&id=5585d19e&scoped=true&"
import script from "./clockDataDetall.vue?vue&type=script&lang=js&"
export * from "./clockDataDetall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585d19e",
  null
  
)

export default component.exports